"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogAlert = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _Body = require("./Body.js");
var _Dialog = require("./Dialog.js");
var _Footer = require("./Footer.js");
var _Title = require("./Title.js");
var _logging = require("../../logging.js");
var _excluded = ["dialogTitle", "dialogTitleId", "id", "body", "footer", "className", "colorSet", "aria-label"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * DialogAlert will display a warning or verify that a user wants to continue and uses tertiary buttons.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-dialogalert--docs) |
 * [Encore site](https://encore.spotify.net/web/components/dialog#alert-dialogs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/DialogAlert) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=0-1208&t=Z5BWCDIk9FWsydIa-1)
 */
var DialogAlert = exports.DialogAlert = /*#__PURE__*/_react["default"].forwardRef(function DialogAlert(_ref, ref) {
  var dialogTitle = _ref.dialogTitle,
    dialogTitleId = _ref.dialogTitleId,
    id = _ref.id,
    body = _ref.body,
    footer = _ref.footer,
    className = _ref.className,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    ariaLabel = _ref['aria-label'],
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var titleId = id && "".concat(id, "-title") || dialogTitleId;
  if (!(dialogTitle && titleId || ariaLabel)) {
    (0, _logging.warn)('Warning: The DialogAlert component must have dialogTitle and an id or an aria-label to be accessible.');
  }
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasBorder = _useState2[0],
    setHasBorder = _useState2[1];
  var bodyId = id && "".concat(id, "-body");
  return /*#__PURE__*/_react["default"].createElement(_Dialog.Dialog, Object.assign({
    ref: ref,
    className: (0, _index.addColorSet)(colorSet, className),
    "aria-label": ariaLabel,
    "aria-describedby": bodyId,
    "aria-labelledby": !ariaLabel && dialogTitle ? titleId : undefined,
    id: id,
    $colorSet: colorSet
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.DialogAlert
  }), dialogTitle && /*#__PURE__*/_react["default"].createElement(_Title.Title, {
    id: titleId,
    $hasBorder: hasBorder,
    $colorSet: colorSet
  }, dialogTitle), /*#__PURE__*/_react["default"].createElement(_Body.Body, {
    id: bodyId,
    onScroll: function onScroll(e) {
      return setHasBorder(e.target instanceof HTMLElement && e.target.scrollTop !== 0);
    }
  }, body), footer && /*#__PURE__*/_react["default"].createElement(_Footer.Footer, null, footer));
});